import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Utils } from 'core/utils';

export interface SingleOptionChooserOption
{
  label: string;
  value: any;
}

@Component({
    selector: 'single-option-chooser',
    templateUrl: './single-option-chooser.component.html',
    styleUrls: ['./single-option-chooser.component.scss'],
    standalone: false
})
export class SingleOptionChooserComponent
{
  @Input() public displayStyle: string;
  @Input() public options: Array<any> = [];
  @Input() public selectedValue: any;
  @Output() public selectedValueChange: EventEmitter<any>
      = new EventEmitter<any>();

  public trackByLabel: (index: number, item: any) => any = Utils.trackByLabel;
}
